export default __webpack_public_path__ + "static/media/room1-BASE.b6917e14.png";